import styled from 'styled-components';

export const Wrapper = styled.div`
    margin-bottom: 3px;
    text-align: initial;    
`;
Wrapper.displayName = 'Wrapper';

export const Title = styled.div`
    font-size: 12.5px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.08;
    letter-spacing: normal;
    color: #0b2128;
    margin-bottom: 10px;
    margin-left: 15px;
    font-weight: 600;
    opacity: ${(props) => (props.disabled ? '0.3' : '1')};
`;
Title.displayName = 'Title';

export const CustomInput = styled.input`
    width: ${(props) => (props.width ? `${props.width}` : '224px')};
    height: ${(props) => (props.height ? `${props.height}` : '38px')};    
    border-bottom: ${(props) => (props.error ? '1px solid red' : 'none')};    
    border-left: none;
    border-top: none;
    border-right: none;
    background-color: ${({ theme, disabled }) => (disabled ? '#edf2f7' : theme.textfield.background)};
    padding-left: 15px;
    padding-right: 42px;
    font-size: 14.5px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.48;
    letter-spacing: normal; 
    color: ${(props) => (props.disabled ? '#90a9c0' : '#1c2243')};
    border-radius: 1px;

    &.full{
        background-color: white; 
    }

    &::placeholder {
        color: ${({ theme }) => theme.text.placeholder};
        font-size: 13.5px;
        font-weight: 300;
    }

    &:hover{
        border: 1px solid #afb1bc;        
    }

    &:focus{
        color: ${({ theme }) => theme.textfield.text};
        &::placeholder {
            color: ${({ theme }) => theme.text.placeholder};
        }
    }

`;
CustomInput.displayName = 'CustomInput';

export const Error = styled.div`
    margin-top: 6px;
    font-size: 10.5px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.08px;
    color: #ea3158;
`;
Error.displayName = 'Error';
